import React from 'react';
import { CheckCircle2, BookOpen, List, Users, Map, Image as ImageIcon } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpen className="w-8 h-8 text-gold" data-id="element-231" />,
    title: 'Guía PDF Legado Digital Seguro',
    desc: 'El manual paso a paso escrito en español claro y sin tecnicismos.'
  }, {
    icon: <List className="w-8 h-8 text-gold" data-id="element-232" />,
    title: 'Inventario de los 4 Pilares',
    desc: 'Una estructura para organizar tus finanzas, comunicaciones, documentos legales y recuerdos.'
  }, {
    icon: <Users className="w-8 h-8 text-gold" data-id="element-233" />,
    title: 'Protocolo de Contacto de Legado',
    desc: 'Instrucciones visuales para configurar quién puede entrar a tu iPhone o Android legalmente.'
  }, {
    icon: <Map className="w-8 h-8 text-gold" data-id="element-234" />,
    title: 'La Hoja de Ruta del Heredero',
    desc: 'Una plantilla lista para imprimir y guardar en tu caja fuerte con las instrucciones exactas para tu familia.'
  }, {
    icon: <ImageIcon className="w-8 h-8 text-gold" data-id="element-235" />,
    title: 'Guía de Rescate de Fotos',
    desc: 'Cómo asegurar que tus nietos hereden tus fotos y no un dispositivo bloqueado.'
  }];
  return <section className="bg-white-soft section-padding" data-id="element-236">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-237">
        Lo que recibes hoy
      </h2>

      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-238">
        {deliverables.map((item, index) => <div key={index} className={`bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start ${index === deliverables.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-239">
            <div className="bg-cream p-3 rounded-lg mr-4 flex-shrink-0" data-id="element-240">
              {item.icon}
            </div>
            <div data-id="element-241">
              <h3 className="text-xl font-bold mb-2 text-navy-dark" data-id="element-242">
                {item.title}
              </h3>
              <p className="text-gray-600" data-id="element-243">{item.desc}</p>
            </div>
          </div>)}
      </div>
    </section>;
}